import type { MultilingualQuestion } from '../../types/multilingualQuestion';

// Multilingual version of Environmental Zones questions
export const environmentalZonesMultilingual: MultilingualQuestion[] = [
  {
    id: 'q-ez-1',
    text: {
      en: 'What is a "milieuzone" (environmental zone) in the Netherlands?',
      nl: 'Wat is een "milieuzone" in Nederland?',
      ar: 'ما هي "منطقة بيئية" (milieuzone) في هولندا؟'
    },
    options: [
      {
        id: 'q-ez-1o1',
        text: {
          en: 'A nature reserve area',
          nl: 'Een natuurreservaat',
          ar: 'منطقة محمية طبيعية'
        }
      },
      {
        id: 'q-ez-1o2',
        text: {
          en: 'A city center with restricted vehicle access',
          nl: 'Een stadscentrum met beperkte toegang voor voertuigen',
          ar: 'مركز مدينة مع وصول محدود للمركبات'
        }
      },
      {
        id: 'q-ez-1o3',
        text: {
          en: 'A parking area for electric vehicles',
          nl: 'Een parkeergebied voor elektrische voertuigen',
          ar: 'منطقة وقوف للمركبات الكهربائية'
        }
      },
      {
        id: 'q-ez-1o4',
        text: {
          en: 'A bicycle-only zone',
          nl: 'Een alleen-fietszone',
          ar: 'منطقة للدراجات فقط'
        }
      }
    ],
    correctAnswerId: 'q-ez-1o2',
    explanation: {
      en: 'A "milieuzone" (environmental zone) is a city center area where certain vehicles are restricted from entering to improve air quality and reduce pollution.',
      nl: 'Een "milieuzone" is een stadscentrumgebied waar bepaalde voertuigen beperkt zijn om binnen te komen om de luchtkwaliteit te verbeteren en vervuiling te verminderen.',
      ar: 'المنطقة البيئية (milieuzone) هي منطقة مركز المدينة حيث يتم تقييد دخول بعض المركبات لتحسين جودة الهواء وتقليل التلوث.'
    },
    subject: 'Environmental Zones'
  },
  {
    id: 'q-ez-2',
    text: {
      en: 'Which vehicles are typically restricted in environmental zones?',
      nl: 'Welke voertuigen zijn meestal beperkt in milieuzones?',
      ar: 'أي مركبات عادة ما تكون مقيدة في المناطق البيئية؟'
    },
    options: [
      {
        id: 'q-ez-2o1',
        text: {
          en: 'All vehicles',
          nl: 'Alle voertuigen',
          ar: 'جميع المركبات'
        }
      },
      {
        id: 'q-ez-2o2',
        text: {
          en: 'Diesel vehicles and older cars',
          nl: 'Dieselvoertuigen en oudere auto\'s',
          ar: 'المركبات التي تعمل بالديزل والسيارات القديمة'
        }
      },
      {
        id: 'q-ez-2o3',
        text: {
          en: 'Electric vehicles only',
          nl: 'Alleen elektrische voertuigen',
          ar: 'المركبات الكهربائية فقط'
        }
      },
      {
        id: 'q-ez-2o4',
        text: {
          en: 'Motorcycles only',
          nl: 'Alleen motorfietsen',
          ar: 'الدراجات النارية فقط'
        }
      }
    ],
    correctAnswerId: 'q-ez-2o2',
    explanation: {
      en: 'Environmental zones typically restrict diesel vehicles and older cars that do not meet current emission standards to improve air quality.',
      nl: 'Milieuzones beperken meestal dieselvoertuigen en oudere auto\'s die niet voldoen aan de huidige emissienormen om de luchtkwaliteit te verbeteren.',
      ar: 'المناطق البيئية عادة ما تقيد المركبات التي تعمل بالديزل والسيارات القديمة التي لا تلبي معايير الانبعاثات الحالية لتحسين جودة الهواء.'
    },
    subject: 'Environmental Zones'
  },
  {
    id: 'q-ez-3',
    text: {
      en: 'What sign indicates the entrance to an environmental zone?',
      nl: 'Welk bord geeft de ingang van een milieuzone aan?',
      ar: 'ما هي العلامة التي تشير إلى مدخل المنطقة البيئية؟'
    },
    options: [
      {
        id: 'q-ez-3o1',
        text: {
          en: 'A red circle with "MILIEUZONE"',
          nl: 'Een rode cirkel met "MILIEUZONE"',
          ar: 'دائرة حمراء مع "MILIEUZONE"'
        }
      },
      {
        id: 'q-ez-3o2',
        text: {
          en: 'A blue circle with "MILIEUZONE"',
          nl: 'Een blauwe cirkel met "MILIEUZONE"',
          ar: 'دائرة زرقاء مع "MILIEUZONE"'
        }
      },
      {
        id: 'q-ez-3o3',
        text: {
          en: 'A green circle with "MILIEUZONE"',
          nl: 'Een groene cirkel met "MILIEUZONE"',
          ar: 'دائرة خضراء مع "MILIEUZONE"'
        }
      },
      {
        id: 'q-ez-3o4',
        text: {
          en: 'A yellow triangle with "MILIEUZONE"',
          nl: 'Een gele driehoek met "MILIEUZONE"',
          ar: 'مثلث أصفر مع "MILIEUZONE"'
        }
      }
    ],
    correctAnswerId: 'q-ez-3o1',
    explanation: {
      en: 'The entrance to an environmental zone is marked with a red circle containing "MILIEUZONE" to indicate restricted access.',
      nl: 'De ingang van een milieuzone is gemarkeerd met een rode cirkel met "MILIEUZONE" om beperkte toegang aan te geven.',
      ar: 'يتم تحديد مدخل المنطقة البيئية بدائرة حمراء تحتوي على "MILIEUZONE" للإشارة إلى الوصول المحدود.'
    },
    subject: 'Environmental Zones'
  },
  {
    id: 'q-ez-4',
    text: {
      en: 'What sign indicates the exit from an environmental zone?',
      nl: 'Welk bord geeft de uitgang van een milieuzone aan?',
      ar: 'ما هي العلامة التي تشير إلى مخرج المنطقة البيئية؟'
    },
    options: [
      {
        id: 'q-ez-4o1',
        text: {
          en: 'A red circle with "MILIEUZONE" and a diagonal line',
          nl: 'Een rode cirkel met "MILIEUZONE" en een diagonale lijn',
          ar: 'دائرة حمراء مع "MILIEUZONE" وخط قطري'
        }
      },
      {
        id: 'q-ez-4o2',
        text: {
          en: 'A blue circle with "MILIEUZONE" and a diagonal line',
          nl: 'Een blauwe cirkel met "MILIEUZONE" en een diagonale lijn',
          ar: 'دائرة زرقاء مع "MILIEUZONE" وخط قطري'
        }
      },
      {
        id: 'q-ez-4o3',
        text: {
          en: 'A green circle with "MILIEUZONE" and a diagonal line',
          nl: 'Een groene cirkel met "MILIEUZONE" en een diagonale lijn',
          ar: 'دائرة خضراء مع "MILIEUZONE" وخط قطري'
        }
      },
      {
        id: 'q-ez-4o4',
        text: {
          en: 'A yellow triangle with "MILIEUZONE" and a diagonal line',
          nl: 'Een gele driehoek met "MILIEUZONE" en een diagonale lijn',
          ar: 'مثلث أصفر مع "MILIEUZONE" وخط قطري'
        }
      }
    ],
    correctAnswerId: 'q-ez-4o1',
    explanation: {
      en: 'The exit from an environmental zone is marked with a red circle containing "MILIEUZONE" with a diagonal line through it.',
      nl: 'De uitgang van een milieuzone is gemarkeerd met een rode cirkel met "MILIEUZONE" met een diagonale lijn erdoorheen.',
      ar: 'يتم تحديد مخرج المنطقة البيئية بدائرة حمراء تحتوي على "MILIEUZONE" مع خط قطري من خلالها.'
    },
    subject: 'Environmental Zones'
  },
  {
    id: 'q-ez-5',
    text: {
      en: 'What is the penalty for entering an environmental zone with a restricted vehicle?',
      nl: 'Wat is de straf voor het binnenrijden van een milieuzone met een beperkt voertuig?',
      ar: 'ما هي العقوبة لدخول منطقة بيئية بمركبة مقيدة؟'
    },
    options: [
      {
        id: 'q-ez-5o1',
        text: {
          en: 'No penalty',
          nl: 'Geen straf',
          ar: 'لا توجد عقوبة'
        }
      },
      {
        id: 'q-ez-5o2',
        text: {
          en: 'A warning letter',
          nl: 'Een waarschuwingsbrief',
          ar: 'رسالة تحذير'
        }
      },
      {
        id: 'q-ez-5o3',
        text: {
          en: 'A fine of €95',
          nl: 'Een boete van €95',
          ar: 'غرامة 95 يورو'
        }
      },
      {
        id: 'q-ez-5o4',
        text: {
          en: 'Vehicle confiscation',
          nl: 'Inbeslagname van voertuig',
          ar: 'مصادرة المركبة'
        }
      }
    ],
    correctAnswerId: 'q-ez-5o3',
    explanation: {
      en: 'Entering an environmental zone with a restricted vehicle typically results in a fine of €95.',
      nl: 'Het binnenrijden van een milieuzone met een beperkt voertuig resulteert meestal in een boete van €95.',
      ar: 'عادة ما يؤدي دخول منطقة بيئية بمركبة مقيدة إلى غرامة 95 يورو.'
    },
    subject: 'Environmental Zones'
  },
  {
    id: 'q-ez-6',
    text: {
      en: 'Which vehicles are usually exempt from environmental zone restrictions?',
      nl: 'Welke voertuigen zijn meestal vrijgesteld van milieuzonebeperkingen?',
      ar: 'أي مركبات عادة ما تكون معفاة من قيود المنطقة البيئية؟'
    },
    options: [
      {
        id: 'q-ez-6o1',
        text: {
          en: 'All vehicles',
          nl: 'Alle voertuigen',
          ar: 'جميع المركبات'
        }
      },
      {
        id: 'q-ez-6o2',
        text: {
          en: 'Emergency vehicles and electric vehicles',
          nl: 'Hulpdienstvoertuigen en elektrische voertuigen',
          ar: 'مركبات الطوارئ والمركبات الكهربائية'
        }
      },
      {
        id: 'q-ez-6o3',
        text: {
          en: 'Only electric vehicles',
          nl: 'Alleen elektrische voertuigen',
          ar: 'المركبات الكهربائية فقط'
        }
      },
      {
        id: 'q-ez-6o4',
        text: {
          en: 'Only emergency vehicles',
          nl: 'Alleen hulpdienstvoertuigen',
          ar: 'مركبات الطوارئ فقط'
        }
      }
    ],
    correctAnswerId: 'q-ez-6o2',
    explanation: {
      en: 'Emergency vehicles and electric vehicles are usually exempt from environmental zone restrictions as they have low or zero emissions.',
      nl: 'Hulpdienstvoertuigen en elektrische voertuigen zijn meestal vrijgesteld van milieuzonebeperkingen omdat ze lage of nul emissies hebben.',
      ar: 'عادة ما تكون مركبات الطوارئ والمركبات الكهربائية معفاة من قيود المنطقة البيئية لأن لديها انبعاثات منخفضة أو صفرية.'
    },
    subject: 'Environmental Zones'
  },
  {
    id: 'q-ez-7',
    text: {
      en: 'How can you check if your vehicle is allowed in an environmental zone?',
      nl: 'Hoe kun je controleren of je voertuig is toegestaan in een milieuzone?',
      ar: 'كيف يمكنك التحقق مما إذا كانت سيارتك مسموحة في منطقة بيئية؟'
    },
    options: [
      {
        id: 'q-ez-7o1',
        text: {
          en: 'Check the RDW website or use the official environmental zone checker',
          nl: 'Controleer de RDW-website of gebruik de officiële milieuzonechecker',
          ar: 'تحقق من موقع RDW أو استخدم فاحص المنطقة البيئية الرسمي'
        }
      },
      {
        id: 'q-ez-7o2',
        text: {
          en: 'Ask a police officer',
          nl: 'Vraag het aan een politieagent',
          ar: 'اسأل ضابط شرطة'
        }
      },
      {
        id: 'q-ez-7o3',
        text: {
          en: 'Try entering and see if you get a fine',
          nl: 'Probeer binnen te rijden en kijk of je een boete krijgt',
          ar: 'حاول الدخول وانظر إذا حصلت على غرامة'
        }
      }
    ],
    correctAnswerId: 'q-ez-7o1',
    explanation: {
      en: 'You can check if your vehicle is allowed in an environmental zone by using the official RDW website or environmental zone checker before entering.',
      nl: 'Je kunt controleren of je voertuig is toegestaan in een milieuzone door de officiële RDW-website of milieuzonechecker te gebruiken voordat je binnenrijdt.',
      ar: 'يمكنك التحقق مما إذا كانت سيارتك مسموحة في منطقة بيئية باستخدام موقع RDW الرسمي أو فاحص المنطقة البيئية قبل الدخول.'
    },
    subject: 'Environmental Zones'
  },
  {
    id: 'q-ez-8',
    text: {
      en: 'What does the "MILIEUZONE" sign with a date indicate?',
      nl: 'Wat geeft het "MILIEUZONE" bord met een datum aan?',
      ar: 'ماذا تشير علامة "MILIEUZONE" مع تاريخ؟'
    },
    options: [
      {
        id: 'q-ez-8o1',
        text: {
          en: 'The date the zone was established',
          nl: 'De datum waarop de zone werd opgericht',
          ar: 'تاريخ إنشاء المنطقة'
        }
      },
      {
        id: 'q-ez-8o2',
        text: {
          en: 'The date from which certain vehicles are restricted',
          nl: 'De datum vanaf wanneer bepaalde voertuigen beperkt zijn',
          ar: 'التاريخ الذي تبدأ فيه قيود بعض المركبات'
        }
      },
      {
        id: 'q-ez-8o3',
        text: {
          en: 'The date the zone will end',
          nl: 'De datum waarop de zone eindigt',
          ar: 'تاريخ انتهاء المنطقة'
        }
      }
    ],
    correctAnswerId: 'q-ez-8o2',
    explanation: {
      en: 'The date on a "MILIEUZONE" sign indicates from which date certain vehicles (typically older diesel vehicles) are restricted from entering.',
      nl: 'De datum op een "MILIEUZONE" bord geeft aan vanaf welke datum bepaalde voertuigen (meestal oudere dieselvoertuigen) beperkt zijn om binnen te komen.',
      ar: 'التاريخ على علامة "MILIEUZONE" يشير إلى التاريخ الذي تبدأ فيه قيود بعض المركبات (عادة المركبات التي تعمل بالديزل القديمة) من الدخول.'
    },
    subject: 'Environmental Zones'
  },
  {
    id: 'q-ez-9',
    text: {
      en: 'What should you do if you accidentally enter an environmental zone with a restricted vehicle?',
      nl: 'Wat moet je doen als je per ongeluk een milieuzone binnenrijdt met een beperkt voertuig?',
      ar: 'ماذا يجب أن تفعل إذا دخلت عن طريق الخطأ منطقة بيئية بمركبة مقيدة؟'
    },
    options: [
      {
        id: 'q-ez-9o1',
        text: {
          en: 'Exit immediately and take an alternative route',
          nl: 'Rijd onmiddellijk uit en neem een alternatieve route',
          ar: 'اخرج فورا واتخذ مسارا بديلا'
        }
      },
      {
        id: 'q-ez-9o2',
        text: {
          en: 'Continue driving to your destination',
          nl: 'Blijf rijden naar je bestemming',
          ar: 'استمر في القيادة إلى وجهتك'
        }
      },
      {
        id: 'q-ez-9o3',
        text: {
          en: 'Park and wait until allowed',
          nl: 'Parkeer en wacht tot het is toegestaan',
          ar: 'اركن وانتظر حتى يسمح'
        }
      }
    ],
    correctAnswerId: 'q-ez-9o1',
    explanation: {
      en: 'If you accidentally enter an environmental zone with a restricted vehicle, exit immediately using the shortest route and take an alternative route to your destination.',
      nl: 'Als je per ongeluk een milieuzone binnenrijdt met een beperkt voertuig, rijd dan onmiddellijk uit via de kortste route en neem een alternatieve route naar je bestemming.',
      ar: 'إذا دخلت عن طريق الخطأ منطقة بيئية بمركبة مقيدة، اخرج فورا باستخدام أقصر مسار واتخذ مسارا بديلا إلى وجهتك.'
    },
    subject: 'Environmental Zones'
  },
  {
    id: 'q-ez-10',
    text: {
      en: 'Which cities in the Netherlands have environmental zones?',
      nl: 'Welke steden in Nederland hebben milieuzones?',
      ar: 'أي مدن في هولندا لديها مناطق بيئية؟'
    },
    options: [
      {
        id: 'q-ez-10o1',
        text: {
          en: 'Only Amsterdam',
          nl: 'Alleen Amsterdam',
          ar: 'أمستردام فقط'
        }
      },
      {
        id: 'q-ez-10o2',
        text: {
          en: 'Amsterdam, Rotterdam, Utrecht, and The Hague',
          nl: 'Amsterdam, Rotterdam, Utrecht en Den Haag',
          ar: 'أمستردام، روتردام، أوتريخت، ولاهاي'
        }
      },
      {
        id: 'q-ez-10o3',
        text: {
          en: 'All major cities',
          nl: 'Alle grote steden',
          ar: 'جميع المدن الكبرى'
        }
      }
    ],
    correctAnswerId: 'q-ez-10o2',
    explanation: {
      en: 'Environmental zones exist in Amsterdam, Rotterdam, Utrecht, and The Hague. Each city may have different restrictions, so check before entering.',
      nl: 'Milieuzones bestaan in Amsterdam, Rotterdam, Utrecht en Den Haag. Elke stad kan verschillende beperkingen hebben, dus controleer voordat je binnenrijdt.',
      ar: 'المناطق البيئية موجودة في أمستردام وروتردام وأوتريخت ولاهاي. قد يكون لكل مدينة قيود مختلفة، لذا تحقق قبل الدخول.'
    },
    subject: 'Environmental Zones'
  },
  {
    id: 'q-ez-11',
    text: {
      en: 'What does the Euro emission standard indicate on a vehicle?',
      nl: 'Wat geeft de Euro-emissienorm aan op een voertuig?',
      ar: 'ماذا يشير معيار الانبعاثات يورو على المركبة؟'
    },
    options: [
      {
        id: 'q-ez-11o1',
        text: { en: 'The year the vehicle was manufactured', nl: 'Het bouwjaar van het voertuig', ar: 'سنة تصنيع المركبة' }
      },
      {
        id: 'q-ez-11o2',
        text: {
          en: 'The level of pollutants the vehicle is allowed to emit',
          nl: 'Het niveau van vervuilende stoffen dat het voertuig mag uitstoten',
          ar: 'مستوى الملوثات التي يُسمح للمركبة بإطلاقها'
        }
      },
      {
        id: 'q-ez-11o3',
        text: { en: 'The fuel type the vehicle uses', nl: 'Het brandstoftype dat het voertuig gebruikt', ar: 'نوع الوقود الذي تستخدمه المركبة' }
      }
    ],
    correctAnswerId: 'q-ez-11o2',
    explanation: {
      en: 'The Euro emission standard (Euro 1-6) indicates the level of pollutants a vehicle is allowed to emit. Older vehicles with lower Euro standards may be restricted from entering environmental zones.',
      nl: 'De Euro-emissienorm (Euro 1-6) geeft het niveau van vervuilende stoffen aan dat een voertuig mag uitstoten. Oudere voertuigen met een lagere Euro-norm kunnen worden beperkt om milieuzones binnen te rijden.',
      ar: 'يشير معيار الانبعاثات يورو (يورو 1-6) إلى مستوى الملوثات التي يُسمح للمركبة بإطلاقها. قد تُقيّد المركبات الأقدم التي لديها معايير يورو أقل من الدخول إلى المناطق البيئية.'
    },
    subject: 'Environmental Zones'
  },
  {
    id: 'q-ez-12',
    text: {
      en: 'How can older vehicles avoid environmental zone restrictions?',
      nl: 'Hoe kunnen oudere voertuigen milieuzonebeperkingen vermijden?',
      ar: 'كيف يمكن للمركبات الأقدم تجنب قيود المناطق البيئية؟'
    },
    options: [
      {
        id: 'q-ez-12o1',
        text: { en: 'Plan alternative routes that avoid the environmental zone', nl: 'Plan alternatieve routes die de milieuzone vermijden', ar: 'خطط لطرق بديلة تتجنب المنطقة البيئية' }
      },
      {
        id: 'q-ez-12o2',
        text: { en: 'Drive at night when restrictions are less enforced', nl: 'Rij ’s nachts wanneer beperkingen minder streng worden gehandhaafd', ar: 'قم بالقيادة في الليل عندما تُطبق القيود بشكل أقل' }
      },
      {
        id: 'q-ez-12o3',
        text: { en: 'Pay a fee to enter the zone', nl: 'Betaal een vergoeding om de zone in te rijden', ar: 'ادفع رسماً للدخول إلى المنطقة' }
      }
    ],
    correctAnswerId: 'q-ez-12o1',
    explanation: {
      en: 'If your vehicle does not meet environmental zone requirements, you should plan alternative routes that avoid the restricted areas. There is no fee system to bypass restrictions in Dutch environmental zones.',
      nl: 'Als je voertuig niet voldoet aan de eisen van de milieuzone, moet je alternatieve routes plannen die de beperkte gebieden vermijden. Er is geen betaalsysteem om beperkingen in Nederlandse milieuzones te omzeilen.',
      ar: 'إذا كانت مركبتك لا تلبي متطلبات المناطق البيئية، فعليك تخطيط طرق بديلة تتجنب المناطق المقيّدة. لا يوجد نظام رسوم لتجاوز القيود في المناطق البيئية الهولندية.'
    },
    subject: 'Environmental Zones'
  },
  {
    id: 'q-ez-13',
    text: {
      en: 'What is the purpose of environmental zones?',
      nl: 'Wat is het doel van milieuzones?',
      ar: 'ما الهدف من المناطق البيئية؟'
    },
    options: [
      { id: 'q-ez-13o1', text: { en: 'To reduce traffic speeds', nl: 'Om de verkeerssnelheid te verlagen', ar: 'لتقليل سرعات حركة المرور' } },
      { id: 'q-ez-13o2', text: { en: 'To reduce air pollution and improve air quality', nl: 'Om luchtvervuiling te verminderen en de luchtkwaliteit te verbeteren', ar: 'لتقليل تلوث الهواء وتحسين جودة الهواء' } },
      { id: 'q-ez-13o3', text: { en: 'To collect tolls from drivers', nl: 'Om tolgelden bij bestuurders te innen', ar: 'لتحصيل رسوم من السائقين' } }
    ],
    correctAnswerId: 'q-ez-13o2',
    explanation: {
      en: 'Environmental zones aim to reduce air pollution by restricting access to high-emission vehicles. This improves air quality in cities and urban areas.',
      nl: 'Milieuzones zijn bedoeld om luchtvervuiling te verminderen door de toegang te beperken voor voertuigen met hoge uitstoot. Dit verbetert de luchtkwaliteit in steden en stedelijke gebieden.',
      ar: 'تهدف المناطق البيئية إلى تقليل تلوث الهواء عبر تقييد الدخول للمركبات الأعلى انبعاثاً. وهذا يحسن جودة الهواء في المدن والمناطق الحضرية.'
    },
    subject: 'Environmental Zones'
  },
  {
    id: 'q-ez-14',
    text: {
      en: 'What types of vehicles are most likely to be restricted in environmental zones?',
      nl: 'Welke soorten voertuigen worden meestal beperkt in milieuzones?',
      ar: 'ما أنواع المركبات الأكثر احتمالاً أن تكون مقيّدة في المناطق البيئية؟'
    },
    options: [
      { id: 'q-ez-14o1', text: { en: 'Electric vehicles and hybrids', nl: 'Elektrische voertuigen en hybrides', ar: 'المركبات الكهربائية والهايبرد' } },
      { id: 'q-ez-14o2', text: { en: 'Older diesel vehicles with low Euro standards', nl: 'Oudere dieselvoertuigen met een lage Euro-norm', ar: 'المركبات الديزل القديمة ذات معايير يورو منخفضة' } },
      { id: 'q-ez-14o3', text: { en: 'Small compact cars', nl: 'Kleine compacte auto’s', ar: 'السيارات الصغيرة المدمجة' } }
    ],
    correctAnswerId: 'q-ez-14o2',
    explanation: {
      en: 'Environmental zones typically restrict older diesel vehicles with low Euro emission standards (Euro 1-3). Newer vehicles and cleaner technologies are generally allowed.',
      nl: 'Milieuzones beperken doorgaans oudere dieselvoertuigen met een lage Euro-emissienorm (Euro 1-3). Nieuwere voertuigen en schonere technologieën zijn meestal toegestaan.',
      ar: 'عادةً ما تقيّد المناطق البيئية المركبات الديزل الأقدم ذات معايير الانبعاثات يورو المنخفضة (يورو 1-3). غالباً ما تكون المركبات الأحدث والتقنيات الأنظف مسموحاً بها.'
    },
    subject: 'Environmental Zones'
  },
  {
    id: 'q-ez-15',
    text: {
      en: 'Can you drive through an environmental zone if your vehicle does not meet the requirements?',
      nl: 'Mag je door een miliezone rijden als je voertuig niet aan de eisen voldoet?',
      ar: 'هل يمكنك القيادة عبر منطقة بيئية إذا كانت مركبتك لا تفي بالمتطلبات؟'
    },
    options: [
      { id: 'q-ez-15o1', text: { en: 'Yes, if you have a valid driving license', nl: 'Ja, als je een geldig rijbewijs hebt', ar: 'نعم، إذا كانت لديك رخصة قيادة سارية' } },
      { id: 'q-ez-15o2', text: { en: 'No, you will receive a fine and a penalty', nl: 'Nee, je krijgt een boete en sanctie', ar: 'لا، ستتعرض لغرامة وعقوبة' } },
      { id: 'q-ez-15o3', text: { en: 'Yes, but only during business hours', nl: 'Ja, maar alleen tijdens kantoortijden', ar: 'نعم، ولكن فقط خلال ساعات العمل' } }
    ],
    correctAnswerId: 'q-ez-15o2',
    explanation: {
      en: 'You cannot drive through an environmental zone with a vehicle that does not meet requirements. Doing so will result in a fine and penalty. You must use alternative routes.',
      nl: 'Je kunt geen milieuzone binnenrijden met een voertuig dat niet aan de eisen voldoet. Dit leidt tot een boete en sanctie. Je moet alternatieve routes gebruiken.',
      ar: 'لا يمكنك القيادة عبر منطقة بيئية بمركبة لا تفي بالمتطلبات. سيؤدي ذلك إلى غرامة وعقوبة. يجب استخدام طرق بديلة.'
    },
    subject: 'Environmental Zones'
  },
  {
    id: 'q-ez-16',
    text: {
      en: 'What is the Euro 6 emission standard?',
      nl: 'Wat is de Euro 6-emissienorm?',
      ar: 'ما هو معيار الانبعاثات يورو 6؟'
    },
    options: [
      { id: 'q-ez-16o1', text: { en: 'The oldest emission standard', nl: 'De oudste emissienorm', ar: 'أقدم معيار لانبعاثات' } },
      { id: 'q-ez-16o2', text: { en: 'The most recent and strictest emission standard', nl: 'De meest recente en strengste emissienorm', ar: 'أحدث وأشد معيار لانبعاثات' } },
      { id: 'q-ez-16o3', text: { en: 'A standard for hybrid vehicles only', nl: 'Een norm voor hybride voertuigen alleen', ar: 'معيار للمركبات الهجينة فقط' } }
    ],
    correctAnswerId: 'q-ez-16o2',
    explanation: {
      en: 'Euro 6 is the most recent and strictest emission standard currently in effect. It applies to vehicles manufactured from 2015 onwards and limits pollutant emissions significantly.',
      nl: 'Euro 6 is momenteel de meest recente en strengste emissienorm. Deze geldt voor voertuigen die vanaf 2015 zijn geproduceerd en beperkt de uitstoot van vervuilende stoffen aanzienlijk.',
      ar: 'يورو 6 هو أحدث وأشد معيار لانبعاثات ساري حالياً. ينطبق على المركبات المصنعة من عام 2015 فصاعداً ويحد من انبعاثات الملوثات بشكل كبير.'
    },
    subject: 'Environmental Zones'
  },
  {
    id: 'q-ez-17',
    text: {
      en: 'How can you check your vehicle\'s Euro emission standard?',
      nl: 'Hoe kun je de Euro-emissienorm van je voertuig controleren?',
      ar: 'كيف يمكنك التحقق من معيار الانبعاثات يورو الخاص بمركبتك؟'
    },
    options: [
      { id: 'q-ez-17o1', text: { en: 'Check the registration document or ask your mechanic', nl: 'Bekijk het kentekenbewijs of vraag het aan je monteur', ar: 'راجع مستند تسجيل المركبة أو اسأل ميكانيكياً' } },
      { id: 'q-ez-17o2', text: { en: 'Look at the color of the license plate', nl: 'Kijk naar de kleur van de kentekenplaat', ar: 'انظر إلى لون لوحة الترخيص' } },
      { id: 'q-ez-17o3', text: { en: 'Ask the local police', nl: 'Vraag het aan de lokale politie', ar: 'اسأل الشرطة المحلية' } }
    ],
    correctAnswerId: 'q-ez-17o1',
    explanation: {
      en: 'Your vehicle\'s Euro emission standard is listed on your vehicle registration document. You can also check online using the RDW website with your license plate number.',
      nl: 'De Euro-emissienorm van je voertuig staat op het kentekenbewijs. Je kunt het ook online controleren via de RDW-website met je kenteken.',
      ar: 'يظهر معيار الانبعاثات يورو لمركبتك في مستند تسجيل المركبة. يمكنك أيضاً التحقق عبر الإنترنت باستخدام موقع RDW مع رقم لوحة الترخيص.'
    },
    subject: 'Environmental Zones'
  },
  {
    id: 'q-ez-18',
    text: {
      en: 'Are commercial vehicles treated differently in environmental zones?',
      nl: 'Worden bedrijfsvoertuigen anders behandeld in milieuzones?',
      ar: 'هل تُعامل المركبات التجارية بشكل مختلف في المناطق البيئية؟'
    },
    options: [
      { id: 'q-ez-18o1', text: { en: 'No, all vehicles have the same restrictions', nl: 'Nee, alle voertuigen hebben dezelfde beperkingen', ar: 'لا، جميع المركبات لها نفس القيود' } },
      { id: 'q-ez-18o2', text: { en: 'Yes, commercial vehicles may have exemptions', nl: 'Ja, bedrijfsvoertuigen kunnen vrijstellingen hebben', ar: 'نعم، قد تُمنح المركبات التجارية إعفاءات' } },
      { id: 'q-ez-18o3', text: { en: 'Only private vehicles are restricted', nl: 'Alleen particuliere voertuigen zijn beperkt', ar: 'لاقتصر التقييد على المركبات الخاصة فقط' } }
    ],
    correctAnswerId: 'q-ez-18o2',
    explanation: {
      en: 'Commercial and delivery vehicles may sometimes have exemptions or different restrictions in environmental zones. Check local regulations for your specific commercial vehicle.',
      nl: 'Bedrijfs- en bestelvoertuigen kunnen soms vrijstellingen of andere beperkingen hebben in milieuzones. Check de lokale regels voor jouw specifieke bedrijfsvoertuig.',
      ar: 'قد تُمنح المركبات التجارية ومركبات التوصيل أحياناً إعفاءات أو قيوداً مختلفة في المناطق البيئية. تحقق من اللوائح المحلية الخاصة بمركبتك التجارية.'
    },
    subject: 'Environmental Zones'
  },
  {
    id: 'q-ez-19',
    text: {
      en: 'What is the fine for driving through an environmental zone with a restricted vehicle?',
      nl: 'Wat is de boete voor rijden door een miliezone met een beperkt voertuig?',
      ar: 'ما هي قيمة الغرامة عند القيادة عبر منطقة بيئية بمركبة مقيّدة؟'
    },
    options: [
      { id: 'q-ez-19o1', text: { en: 'Warning only', nl: 'Alleen waarschuwing', ar: 'تحذير فقط' } },
      { id: 'q-ez-19o2', text: { en: 'Fine of €95 to €500 depending on the city', nl: 'Boete van €95 tot €500 afhankelijk van de stad', ar: 'غرامة من 95 يورو إلى 500 يورو حسب المدينة' } },
      { id: 'q-ez-19o3', text: { en: 'License points only, no fine', nl: 'Alleen rijpunten, geen boete', ar: 'نقاط على الرخص فقط دون غرامة' } }
    ],
    correctAnswerId: 'q-ez-19o2',
    explanation: {
      en: 'Driving through an environmental zone with a non-compliant vehicle results in fines ranging from €95 to €500 depending on which city\'s environmental zone you violate.',
      nl: 'Rijden door een miliezone met een niet-conform voertuig leidt tot boetes van €95 tot €500, afhankelijk van welke miliezone van welke stad je overtreedt.',
      ar: 'تؤدي القيادة عبر منطقة بيئية بمركبة غير ملتزمة إلى غرامات تتراوح بين 95 يورو و500 يورو حسب المنطقة/المدينة التي تنتهكها.'
    },
    subject: 'Environmental Zones'
  },
  {
    id: 'q-ez-20',
    text: {
      en: 'Are electric vehicles allowed in all environmental zones?',
      nl: 'Zijn elektrische voertuigen toegestaan in alle milieuzones?',
      ar: 'هل يُسمح للمركبات الكهربائية بالدخول إلى جميع المناطق البيئية؟'
    },
    options: [
      { id: 'q-ez-20o1', text: { en: 'No, they are restricted like diesel vehicles', nl: 'Nee, ze zijn beperkt net als dieselvoertuigen', ar: 'لا، تُقيد مثل مركبات الديزل' } },
      { id: 'q-ez-20o2', text: { en: 'Yes, electric vehicles are generally exempt from restrictions', nl: 'Ja, elektrische voertuigen zijn doorgaans vrijgesteld van beperkingen', ar: 'نعم، تُعفى المركبات الكهربائية عادةً بشكل عام' } },
      { id: 'q-ez-20o3', text: { en: 'Only during specific hours', nl: 'Alleen tijdens specifieke uren', ar: 'فقط خلال ساعات محددة' } }
    ],
    correctAnswerId: 'q-ez-20o2',
    explanation: {
      en: 'Electric vehicles are generally exempt from environmental zone restrictions because they produce zero local emissions. They can usually enter any environmental zone regardless of location or time.',
      nl: 'Elektrische voertuigen zijn doorgaans vrijgesteld van milieuzonebeperkingen omdat ze lokaal geen uitstoot hebben. Ze kunnen meestal elke miliezone binnenrijden, ongeacht locatie of tijd.',
      ar: 'عادةً ما تُعفى المركبات الكهربائية من قيود المناطق البيئية لأنها تنتج انبعاثات محلية معدومة. ويمكنها عادةً الدخول إلى أي منطقة بيئية بغض النظر عن الموقع أو الوقت.'
    },
    subject: 'Environmental Zones'
  },
  {
    id: 'q-ez-21',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/risk-awareness/q-ra-22-residential-zone.jpg',
    text: {
      en: 'In residential zones, what must you observe regarding parking?',
      nl: 'In woongebieden: wat moet je opmerken met betrekking tot parkeren?',
      ar: 'في المناطق السكنية، ما الذي يجب عليك ملاحظته فيما يتعلق بالوقوف؟'
    },
    options: [
      {
        id: 'q-ez-21o1',
        text: {
          en: 'Park anywhere within the zone',
          nl: 'Park overal in de zone',
          ar: 'اوقف في أي مكان ضمن المنطقة'
        }
      },
      {
        id: 'q-ez-21o2',
        text: {
          en: 'Park only in marked parking spaces and follow all local parking signs and regulations',
          nl: 'Park alleen op aangewezen parkeerplaatsen en volg alle lokale parkeerregels en -voorschriften',
          ar: 'اوقف فقط في مواقف محددة واتبع جميع علامات ولوائح الوقوف المحلية'
        }
      },
      {
        id: 'q-ez-21o3',
        text: {
          en: 'Parking is always prohibited in residential zones',
          nl: 'Parkeren is altijd verboden in woongebieden',
          ar: 'الوقوف محظور دائما في المناطق السكنية'
        }
      }
    ],
    correctAnswerId: 'q-ez-21o2',
    explanation: {
      en: 'In residential zones, you must park only in designated parking spaces and follow all posted parking signs and local regulations. Improper parking can result in fines and vehicle removal. (RVV 1990 art. 12)',
      nl: 'In woongebieden mag je alleen op aangewezen parkeerplaatsen parkeren en moet je alle aangekondigde parkeerregels en lokale bepalingen volgen. Onjuist parkeren kan tot boetes en voertuigverwijdering leiden. (RVV 1990 art. 12)',
      ar: 'في المناطق السكنية، يجب عليك الوقوف فقط في مواقف محددة واتباع جميع علامات الوقوف المعلنة واللوائح المحلية. قد يؤدي الوقوف غير الصحيح إلى غرامات وإزالة المركبة. (RVV 1990 art. 12)'
    },
    subject: 'Environmental Zones'
  }
];

























